"use strict";
var Observable_1 = require('../../Observable');
var bindCallback_1 = require('../../observable/bindCallback');
Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
//# sourceMappingURL=bindCallback.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/observable/bindCallback.js